import React, { useEffect, useState } from 'react';
import { Card, List, Tag, Badge, Empty, Typography, Button } from 'antd';
import { WarningOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getParentRequests } from '../../api/parentRequests';
import useAuthStore from '../../store/authStore';

const { Text } = Typography;
const PAGE_SIZE = 5;

const TYPE_LABELS = {
  absence: 'Devamsızlık Bildirimi',
  makeup: 'Telafi Hakkı Kullanma',
};
// /users/:id sadece MANAGER_ROLES icin acik (App.js) - bu widget ogretmen
// dashboard'unda da gorundugu icin veli linki sadece yonetici rolleri
// icin tiklanabilir gosteriliyor.
const CAN_VIEW_USER_DETAIL_ROLES = ['developer_admin', 'super_admin', 'branch_manager'];

const ParentRequestsPendingPanel = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const canViewUserDetail = CAN_VIEW_USER_DETAIL_ROLES.includes(user?.role);
  const [collapsed, setCollapsed] = useState(true);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ current: 1, pageSize: PAGE_SIZE, total: 0 });

  const fetchItems = (page = 1) => {
    setLoading(true);
    getParentRequests({ status: 'pending', page, per_page: PAGE_SIZE })
      .then((res) => {
        setItems(res.data.data);
        setPagination({
          current: res.data.current_page,
          pageSize: res.data.per_page,
          total: res.data.total,
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchItems(1); }, []);

  return (
    <Card
      size="small"
      title={
        <span
          className="cursor-pointer select-none flex items-center gap-2"
          onClick={() => setCollapsed((c) => !c)}
        >
          {collapsed ? <RightOutlined style={{ fontSize: 11, color: '#9ca3af' }} /> : <DownOutlined style={{ fontSize: 11, color: '#9ca3af' }} />}
          <WarningOutlined style={{ color: '#fa8c16' }} />
          Veli Talepleri — Bekleyen
          <Badge count={pagination.total} style={{ backgroundColor: pagination.total > 0 ? '#faad14' : '#d9d9d9' }} />
        </span>
      }
      style={{ marginBottom: 16 }}
    >
      {!collapsed && (
        <List
          size="small"
          loading={loading}
          dataSource={items}
          locale={{ emptyText: <Empty description="Bekleyen veli talebi yok." image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            size: 'small',
            hideOnSinglePage: true,
            onChange: (page) => fetchItems(page),
          }}
          renderItem={(item) => (
            <List.Item>
              <div className="w-full">
                <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                  <Tag color="gold" style={{ margin: 0 }}>{TYPE_LABELS[item.type] || item.type}</Tag>
                  <Text type="secondary" className="text-xs">
                    {dayjs(item.created_at).format('DD.MM.YYYY HH:mm')}
                  </Text>
                </div>
                <div className="text-sm text-gray-700 mt-0.5">
                  {item.student ? (
                    <Button type="link" style={{ padding: 0, height: 'auto' }} onClick={() => navigate(`/students/${item.student.id}`)}>
                      {item.student.name} {item.student.surname}
                    </Button>
                  ) : '-'}
                  {item.parent_user?.name && (
                    canViewUserDetail ? (
                      <>
                        {' — '}
                        <Button type="link" style={{ padding: 0, height: 'auto' }} onClick={() => navigate(`/users/${item.parent_user.id}`)}>
                          {item.parent_user.name} {item.parent_user.surname}
                        </Button>
                      </>
                    ) : ` — ${item.parent_user.name} ${item.parent_user.surname}`
                  )}
                </div>
              </div>
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default ParentRequestsPendingPanel;
